import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_APPSEBRAE}${process.env.VUE_APP_API_PATH}/appsebrae/uabs/consultorias`

export default {
    obterTodasConsultorias() {
        return axiosJwt
            .get(`${api}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConsultoriaPorId(consultoriaId) {
        return axiosJwt
            .get(`${api}/${consultoriaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
